export function generateTwitterTags() {
  // @docs: https://developer.x.com/en/docs/x-for-websites/cards/guides/getting-started
  // realy on OG to define the rest, per X documentaion
  return [
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:site', content: '@EddyRecio' }, // @username for the website used in the card footer.
    { name: 'twitter:creator', content: '@EddyRecio' }, // @username for the content creator / author.
  ];
}
